//@flow
import React from 'react';
import { Container } from 'flux/utils';
import ExperimentsStore from '../../Stores/Experiments/experimentsStore';

type Props = {
  name:string,
  version?:string|string[],
  children:?React$Node,
  hide?:boolean,
};

type State = {
  enabled:boolean,
};

function expWrapper(ifEnabled:boolean):React$ComponentType<Props> {
  class ExperimentWrapper extends React.Component<Props, State> {
    static getStores() {
      return [
        ExperimentsStore,
      ];
    }

    static calculateState(prevState:State, props:Props):State {
      let enabled = ExperimentsStore.isEnabled(props.name);
      if (props.version) {
        const versions = [].concat(props.version);
        enabled = enabled &&
          versions.includes(ExperimentsStore.getExperimentVersion(props.name));
      }
      return {
        enabled: ifEnabled ? enabled : !enabled,
      };
    }

    render() {
      if (!this.state.enabled || !this.props.children || this.props.hide) return null;

      return this.props.children;
    }
  }

  return Container.create(ExperimentWrapper, { withProps: true });
}

export const IfExperiment = expWrapper(true);
export const IfNotExperiment = expWrapper(false);
